type LoggedInFormValidType = {
  readonly isValid: boolean;
};
type LoggedInFormValidActionType = {
  readonly type: string;
  readonly payload?: LoggedInFormValidType;
};

// Actions
const SET_FORM_VALID = 'logged-in-form-valid/SET_FORM_VALID';

// Initial State
const initialState: LoggedInFormValidType = {
  isValid: false
};

// Reducer
export const loggedInFormValidReducer = (
  state = initialState,
  action: LoggedInFormValidActionType
): LoggedInFormValidType => {
  switch (action.type) {
    case SET_FORM_VALID:
      return Object.assign({}, state, { isValid: action.payload?.isValid });
    default:
      return state;
  }
};

// Action Creators
export function updateLoggedInFormValid(
  isValid: boolean
): LoggedInFormValidActionType {
  return {
    type: SET_FORM_VALID,
    payload: {
      isValid
    }
  };
}
